<template>
    <div class="column additonal-info-place modal">
        
        <form @submit.prevent class="form box ">
            
            <button 
                    @click="closeModal"
                    :class="{'is-loading':is_loading || !current_user}"
                    class="button ml-3 is-secondary has-text-weight-bold is-danger is-pulled-right">
                    <span class="icon"><i class="fas fa-times"></i></span>
                </button>

            <div class="additonal-info">
                
                <h1 class="title mb-0 is-3">Additonal Info</h1>
                <div class="content is-medium mb-1">
                    <p>A little more info makes this info a lot more useful</p>
                </div>

                <div class="field">
                    <label for="category" class="label is-large is-tight">Category</label>
                    <div class="control is-medium">
                        <div class="select is-medium">
                            <select id="category" v-model="report.category"> 
                                <option value="">-</option>
                                <option value="speeding">Speeding</option>
                                <option value="tailgating">Tailgating</option>
                                <option value="no-stop">Didn't stop at a light/crossing</option>
                                <option value="parking">Parked dangerously / badly</option>
                                <option value="indication">Indicating badly or not at all</option>
                                <option value="phone">Using a phone</option>
                                <option value="other">Other</option>
                            </select>
                        </div>
                        
                    </div>
                </div>
                
                <div class="field">
                    <label for="category" class="label is-large is-tight">Seriousness</label>
                    <div class="control is-medium">
                        <div class="select is-medium">
                            <select id="category" v-model="report.seriousness"> 
                                <option value="">-</option>
                                <option value="1">1 - Dangeroues</option>
                                <option value="2">2 - Risky</option>
                                <option value="3">3 - Awkward</option>                                
                                <option value="4">4 - Inconsiderate</option>
                                <option value="5">5 - Iritating</option>
                            </select>
                        </div>
                        
                    </div>
                </div>

                <div class="field">
                    <label for="category" class="label is-large is-tight">Feeling</label>
                    <div class="control is-medium">
                        <div class="select is-medium">
                            <select id="category" v-model="report.feelings"> 
                                <option value="">-</option>
                                <option value="angry">Angry</option>
                                <option value="scared">Scared</option>
                                <option value="upset">Upset</option>
                                <option value="upset">Irritated</option>
                            </select>
                        </div>
                        
                    </div>
                </div>

                <div class="field mt-5">
                
                    <div class="buttons  is-right">

                        <button v-if="Object.keys(report).length > 0"
                            @click="startSubmitAdditionalDetails"
                            :class="{'is-loading':is_loading || !current_user}"
                            class="button is-primary is-large has-text-weight-bold">
                            ADD INFO
                        </button>

                        <button v-else
                            @click="$router.push(next_path)"
                            :class="{'is-loading':is_loading || !current_user}"
                            class="button is-primary is-light is-large has-text-weight-bold">
                            SKIP
                        </button>

                        

                    </div>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
import { mapGetters,mapActions } from "vuex";

export default {
    props: {
        registration: String
    },
    data() {
        return {
            report: {},
            next_path: '/incident/' + this.registration,
        }
    },
    computed: {
        ...mapGetters({
            is_loading: "is_loading",
            current_user: "current_user"
        }),
    },
    methods: {
        ...mapActions({
            updateRegistration: "updateRegistration",
            loading: "loading",
            setMessage: 'setMessage'
        }),
        startSubmitAdditionalDetails() {
            this.loading(true)
            var submission = { 
                number_plate: this.registration,
                next_path: this.next_path, 
                details: this.report
            }
            this.updateRegistration(submission).then(()=>{
                
            }).catch(()=>{
                this.loading(false)
            })
        },
        closeModal() {
            this.setMessage({text:"Number plate registration "+ this.registration + " has been sucessfully nominated",type:'is-success'})
            this.$router.push('/')
        }
    }
}
</script>